import { DateTime } from "luxon";

export function renderShortAbsoluteTimestamp(now: DateTime, timestamp: string) {
  const date = DateTime.fromISO(timestamp);

  // Today
  if (date.hasSame(now, "day")) {
    return date.toLocaleString(DateTime.TIME_SIMPLE);
  }

  // Less than a year ago
  if (date.diff(now, "years").years < 1) {
    return date.toLocaleString({
      month: "short",
      day: "numeric",
    });
  }

  // More than a year ago
  return date.toLocaleString(DateTime.DATE_MED);
}
